var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-StandardActivities",
    transform: "translate(-1376.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-edit",
    transform: "translate(1377.000000, 204.000000)",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.058824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93103448,1.73706389 L13.7931034,5.57073529",
    id: "Stroke-352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.551724138,11.0474087 L4.4137931,14.8810801",
    id: "Stroke-353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4137931,14.8810801 L2.14939178e-13,15.4287475 L0.551724138,11.0474087 L11.3577931,0.320796146 C11.7886897,-0.106932049 12.4871724,-0.106932049 12.918069,0.320796146 L15.2198621,2.6056643 C15.6507586,3.03339249 15.6507586,3.72673935 15.2198621,4.15446755 L4.4137931,14.8810801 L4.4137931,14.8810801 Z",
    id: "Stroke-355"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.da4a97bc4578b81fe3646ee27e8fced5.svg";
export { ForwardRef as ReactComponent };